import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["accountId"],
  _excluded2 = ["accountId"],
  _excluded3 = ["accountId"],
  _excluded4 = ["accountId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { accountRoutes } from './routes';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
import { parseJwt } from 'src/core/services/jwt';
export class Account {
  constructor() {
    _defineProperty(this, "routes", accountRoutes);
  }
  isLoggedIn() {
    const accessToken = localStorage.getItem(AUTH_TOKEN_KEYS.accessToken);
    return !!accessToken && accessToken !== 'null';
  }
  isDemoModeOn() {
    const accessToken = localStorage.getItem(AUTH_TOKEN_KEYS.accessToken);
    if (!!accessToken && accessToken !== 'null') {
      const data = parseJwt(accessToken);
      return data && data['custom:testmode'] === 'Demo';
    }
    return false;
  }
  async registerNewAccount(data, options) {
    const resp = await requestService('auth').post(this.routes.baseUrl, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getProfile(options) {
    const resp = await requestService('auth').get(this.routes.baseUrl, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateProfile(data, options) {
    const resp = await requestService('auth').put(this.routes.baseUrl, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async confirmAnAccountsEmail(data, options) {
    const resp = await requestService('auth').post(this.routes.confirm, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async resendCodeToConfirmAccountEmail(data, options) {
    const resp = await requestService('auth').post(this.routes.sendConfirmation, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async disableMFA(data, options) {
    // delete(url, body, config): the method rides in the query string, and the body stays empty.
    const resp = await requestService('auth').delete(this.routes.mfa, null, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: {
        method: data.method
      }
    }));
    return resp.data;
  }
  async enableMFA(data, options) {
    const resp = await requestService('auth').post(this.routes.mfa, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async associateTotp(options) {
    const resp = await requestService('auth').post(this.routes.mfaTotpAssociate, null, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async verifyTotp(data, options) {
    const resp = await requestService('auth').post(this.routes.mfaTotpVerify, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updatePhoneNumber(data, options) {
    const resp = await requestService('auth').put(this.routes.phone, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async confirmPhoneNumber(data, options) {
    const resp = await requestService('auth').put(this.routes.confirmPhone, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async mfaLogin(data, options) {
    const resp = await requestService('auth').post(this.routes.mfaLogin, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async login(data, options) {
    const resp = await requestService('auth').post(this.routes.login, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async loginPM(data, options) {
    const resp = await requestService('auth').post(this.routes.loginPM, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async refreshAccessToken(data, options) {
    const resp = await requestService('auth').post(this.routes.refreshToken, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async loginInvite(data, options) {
    const resp = await requestService('auth').post(this.routes.loginInvite, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async changeTemporaryInvitePassword(data, options) {
    const resp = await requestService('auth').post(this.routes.changeTemporaryPassword, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async forgotPassword(data, options) {
    const resp = await requestService('auth').post(this.routes.forgotPassword, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async resetPassword(data, options) {
    const resp = await requestService('auth').post(this.routes.resetPassword, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async logout(data, options) {
    const resp = await requestService('auth').post(this.routes.logoutToken, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async changeTemporaryPassword(data, options) {
    const resp = await requestService('auth').post(this.routes.password, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async inviteNewUser(data, options) {
    const resp = await requestService('auth').post(this.routes.invite, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async inviteNewUserV2(data, options) {
    const resp = await requestService('auth').post(this.routes.invitev2, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async reInviteUser(data, options) {
    const resp = await requestService('auth').get(this.routes.reInvite(data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getUsersProfiles(data, options) {
    const resp = await requestService('auth').post(this.routes.profiles, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async enrollUser(data, options) {
    const resp = await requestService('auth').post(this.routes.enroll, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateProfileByAccountId(data, options) {
    const accountId = data.accountId,
      rest = _objectWithoutProperties(data, _excluded);
    const resp = await requestService('auth').put(this.routes.updateProfileByAccountId(accountId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updatePhoneByAccountId(data, options) {
    const accountId = data.accountId,
      rest = _objectWithoutProperties(data, _excluded2);
    const resp = await requestService('auth').put(this.routes.updatePhoneByAccountId(accountId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateUsersPortalAccessDate(data, options) {
    const accountId = data.accountId,
      rest = _objectWithoutProperties(data, _excluded3);
    const resp = await requestService('auth').put(this.routes.updateUsersPortalAccessDate(accountId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateEmailByAccountId(data, options) {
    const accountId = data.accountId,
      rest = _objectWithoutProperties(data, _excluded4);
    const resp = await requestService('auth').put(this.routes.updateEmailByAccountId(accountId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async setTeamMemberAccess(data, options) {
    const accountId = data.accountId,
      userRole = data.userRole,
      propertyIds = data.propertyIds,
      portfolioIds = data.portfolioIds;
    const resp = await requestService('auth').put(this.routes.teamMemberAccess, {
      accountId,
      userRole,
      propertyIds,
      portfolioIds
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async assignResourceTeamMember(data, options) {
    const propertyId = data.propertyId,
      portfolioId = data.portfolioId,
      accountIds = data.accountIds;
    const resp = await requestService('auth').put(this.routes.assignResourceTeamMember, {
      propertyId,
      portfolioId,
      accountIds
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getFeatureFlags(options) {
    const resp = await requestService('auth').get(this.routes.featureFlags, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updatePassword(data, options) {
    const resp = await requestService('auth').put(this.routes.password, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async enableDemoMode(_ref, options) {
    let _ref$isEnabled = _ref.isEnabled,
      isEnabled = _ref$isEnabled === void 0 ? false : _ref$isEnabled;
    const resp = await requestService('auth').post(this.routes.demoMode, {
      isEnabled
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getUsersSubAccounts(options) {
    const resp = await requestService('auth').get(this.routes.subAccounts, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postSwitchUsersSubAccount(data, options) {
    const resp = await requestService('auth').post(this.routes.switchSubAccount, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async validateEmail(data, options) {
    const resp = await requestService('auth').post(this.routes.emailValidation, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}